import Item from './Item';

export default class DynamicProppingAncestor extends Item {
  adaptPropping() {
    const children = this.getAllChildren();
    children.forEach(child => {
      if (child.adaptPropping) {
        child.adaptPropping();
      }
    });
  }

  addSprite(sprite, slot, tac) {
    let oldParent;
    if (sprite.parentItem && sprite.parentItem.itemid !== slot.parent.itemid) {
      oldParent = this.app.itemContainer.getSprite(sprite.parentItem.itemid);
    }
    super.addSprite(sprite, slot, tac);
    if (oldParent && oldParent.adaptPropping) {
      oldParent.adaptPropping();
    }

    this.adaptPropping();
  }
}
